/**
 * @generated SignedSource<<fae6dc9963c2cb70c50a749af89545fe>>
 * @relayHash 7c0e4d8486e54ba6e102ec5009505b19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3b4a148a7952924e53af4161b0a5fc2ad94790986d10c32d96e9d7b55976cd6f

import type { ConcreteRequest } from 'relay-runtime';
export type useContentTitlesQuery$variables = {
  ids: ReadonlyArray<string>;
};
export type useContentTitlesQuery$data = {
  readonly databaseContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly title: string | null;
    } | null> | null;
  } | null;
  readonly embedContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly title: string | null;
    } | null> | null;
  } | null;
  readonly folderContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly title: string | null;
    } | null> | null;
  } | null;
  readonly pageContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly title: string | null;
    } | null> | null;
  } | null;
  readonly whiteboardContent: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly title: string | null;
    } | null> | null;
  } | null;
};
export type useContentTitlesQuery = {
  response: useContentTitlesQuery$data;
  variables: useContentTitlesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = {
  "kind": "Variable",
  "name": "ids",
  "variableName": "ids"
},
v2 = [
  {
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      }
    ]
  }
],
v3 = [
  {
    "alias": "pageContent",
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": "page"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v2/*: any*/)
  },
  {
    "alias": "folderContent",
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": "folder"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v2/*: any*/)
  },
  {
    "alias": "whiteboardContent",
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": "whiteboard"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v2/*: any*/)
  },
  {
    "alias": "databaseContent",
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": "database"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v2/*: any*/)
  },
  {
    "alias": "embedContent",
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "type",
        "value": "embed"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": (v2/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContentTitlesQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContentTitlesQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "7c0e4d8486e54ba6e102ec5009505b19",
    "id": "3b4a148a7952924e53af4161b0a5fc2ad94790986d10c32d96e9d7b55976cd6f",
    "metadata": {},
    "name": "useContentTitlesQuery",
    "operationKind": "query",
    "text": "query useContentTitlesQuery($ids:[ID!]!){pageContent:content(ids:$ids,type:\"page\"){nodes{id,title}},folderContent:content(ids:$ids,type:\"folder\"){nodes{id,title}},whiteboardContent:content(ids:$ids,type:\"whiteboard\"){nodes{id,title}},databaseContent:content(ids:$ids,type:\"database\"){nodes{id,title}},embedContent:content(ids:$ids,type:\"embed\"){nodes{id,title}}}"
  }
};
})();

(node as any).hash = "503b371610f42e1634360824bac2cefe";

export default node;
